import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postPrevisionLiquidacionesApi } from '../../../../api/axios.js';
import { fetchSellersFilterLiquidaciones } from '../../../../actions/sellersActions';
import { DropDownArrow, customStyleFilterWrap, filterSelectMenuPortalProps } from '../../../../template/CustomStyle';
import { toast } from '../../../../utilities/appToast';
import { filtroMedioMes, fechaLimite } from '../../../../utilities/fechasFiltro';
import Select from 'react-select';
import '../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../shared/LiquidacionesPageHeader';
import LiquidacionesFilterCard from '../../shared/LiquidacionesFilterCard';
import { LiquidacionesBtnCrear } from '../../shared/LiquidacionesButtons';
import { LIQUIDACIONES_ROUTES } from '../../shared/liquidacionesRoutes';
import BigSpinner from '../../../General/BigSpinner';
import './LiquidacionDetalleTabla.css';

const PREVISION_MAX_DIAS_RANGO = 60;
const PREVISION_MODO = {
    SELLERS: 'sellers',
    DIA_CORTE: 'diaCorte'
};

const PREVISION_DIAS_CORTE_OPTIONS = [
    { label: '15', value: '15' },
    { label: '21', value: '21' },
    { label: '30', value: '30' }
];

const fechaFiltro = filtroMedioMes();
const fechaDesdeMinima = fechaLimite();

function PrevisionLiquidacionesWrapper(props) {
    const navigate = useNavigate();
    return <PrevisionLiquidaciones {...props} navigate={navigate} />;
}

const toDateString = (date) => {
    const pad = (v) => String(v).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

const addDaysToDate = (dateStr, days) => {
    if (!dateStr) return '';
    const date = new Date(`${dateStr}T00:00:00`);
    if (Number.isNaN(date.getTime())) return '';
    date.setDate(date.getDate() + days);
    return toDateString(date);
};

const getDayDiff = (fromDateStr, toDateStr) => {
    if (!fromDateStr || !toDateStr) return 0;
    const from = new Date(`${fromDateStr}T00:00:00`);
    const to = new Date(`${toDateStr}T00:00:00`);
    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return 0;
    return Math.floor((to - from) / 86400000);
};

class PrevisionLiquidaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingSellersOptions: false,
            isLoadingSubmit: false,
            resultadoPrevision: null,
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            modoPrevision: PREVISION_MODO.DIA_CORTE,
            diaCorte: PREVISION_DIAS_CORTE_OPTIONS[0],
            sellers: []
        };
    }

    isAuthorizedViewAll = () => [1, 2, 8].includes(this.props.tipoUsuario);

    componentDidMount() {
        if (!this.isAuthorizedViewAll()) {
            toast.warn('No tenés permisos para generar previsión');
            this.goBack();
        }
    }

    goBack = () => {
        this.props.navigate(LIQUIDACIONES_ROUTES.liquidaciones);
    }

    myChangeHandler = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => {
            const nextState = { [name]: value };
            const fechaDesde = name === 'fechaDesde' ? value : prevState.fechaDesde;
            const fechaHasta = name === 'fechaHasta' ? value : prevState.fechaHasta;
            const diff = getDayDiff(fechaDesde, fechaHasta);

            if (diff > PREVISION_MAX_DIAS_RANGO) {
                if (name === 'fechaDesde') {
                    nextState.fechaHasta = addDaysToDate(value, PREVISION_MAX_DIAS_RANGO);
                } else {
                    nextState.fechaDesde = addDaysToDate(value, -PREVISION_MAX_DIAS_RANGO);
                }
            }

            return nextState;
        });
    }

    selectSellers = (options) => {
        const sellers = Array.isArray(options)
            ? options.map((option) => ({ label: option.label, value: option.value.toString() }))
            : [];

        this.setState({ sellers });
    }

    removeSeller = (sellerValue) => {
        this.setState((prevState) => ({
            sellers: prevState.sellers.filter((seller) => seller.value !== sellerValue)
        }));
    }

    selectDiaCorte = (option) => {
        this.setState({ diaCorte: option });
    }

    setModoPrevision = (modoPrevision) => {
        this.setState((prevState) => {
            if (prevState.modoPrevision === modoPrevision) return null;

            if (modoPrevision === PREVISION_MODO.SELLERS) {
                return {
                    modoPrevision,
                    diaCorte: PREVISION_DIAS_CORTE_OPTIONS[0]
                };
            }

            return {
                modoPrevision,
                sellers: []
            };
        });
    }

    mapSellers = async () => {
        if (this.state.isLoadingSellersOptions) return;
        if (Array.isArray(this.props.lista_sellers_liquidaciones) && this.props.lista_sellers_liquidaciones.length > 0) return;

        this.setState({ isLoadingSellersOptions: true });
        try {
            await this.props.fetchSellersFilterLiquidaciones({
                Descripcion: '',
                Page: 1,
                PageSize: 100
            });
        } finally {
            this.setState({ isLoadingSellersOptions: false });
        }
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        if (action.action === 'input-change') {
            this.setState({ isLoadingSellersOptions: true });
            this.props.fetchSellersFilterLiquidaciones({
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            }).finally(() => {
                this.setState({ isLoadingSellersOptions: false });
            });
        }
        return descripcion;
    }

    getSellerIdsForSubmit = () => {
        if (!this.isAuthorizedViewAll()) {
            return this.props.idSeller ? [this.props.idSeller] : [];
        }

        const ids = this.state.sellers
            .map((seller) => Number.parseInt(seller.value, 10))
            .filter((id) => !Number.isNaN(id));

        return Array.from(new Set(ids));
    }

    onSubmit = async (event) => {
        event.preventDefault();
        if (this.state.isLoadingSubmit) return;

        const { fechaDesde, fechaHasta, diaCorte, modoPrevision } = this.state;

        if (!fechaDesde) {
            toast.warn('Debe seleccionar una fecha inicial');
            return;
        }

        if (!fechaHasta) {
            toast.warn('Debe seleccionar una fecha final');
            return;
        }

        const diff = getDayDiff(fechaDesde, fechaHasta);
        if (diff < 0) {
            toast.warn('La fecha Hasta no puede ser anterior a la fecha Desde');
            return;
        }

        if (diff > PREVISION_MAX_DIAS_RANGO) {
            toast.warn(`El rango máximo permitido entre fechas es de ${PREVISION_MAX_DIAS_RANGO} días`);
            return;
        }

        const payload = {
            fechaDesde,
            fechaHasta
        };

        if (modoPrevision === PREVISION_MODO.SELLERS) {
            const idSellers = this.getSellerIdsForSubmit();
            if (idSellers.length === 0) {
                toast.warn('Debe seleccionar al menos un Seller');
                return;
            }
            payload.idSellers = idSellers;
        } else {
            const diaCorteValue = Number.parseInt(diaCorte?.value ?? '', 10);
            if (Number.isNaN(diaCorteValue)) {
                toast.warn('Debe seleccionar un día de corte');
                return;
            }
            payload.diaCorte = diaCorteValue;
        }

        this.setState({ isLoadingSubmit: true });
        try {
            const response = await postPrevisionLiquidacionesApi(payload);
            const data = response?.data ?? {};
            const errores = Array.isArray(data?.errores) ? data.errores : [];

            this.setState({
                resultadoPrevision: {
                    totalGeneral: Number(data?.totalGeneral ?? 0),
                    cantidadSellers: Number(data?.cantidadSellers ?? 0),
                    cantidadOrdenes: Number(data?.cantidadOrdenes ?? 0),
                    sellers: Array.isArray(data?.sellers) ? data.sellers : [],
                    errores
                }
            });

            if (errores.length > 0) {
                const mensaje = errores?.[0]?.item2 ?? errores?.[0]?.Item2 ?? 'La previsión se generó con observaciones';
                toast.warn(mensaje);
            } else {
                toast.success('La previsión se generó correctamente');
            }
        } catch (error) {
            const errores = error?.response?.data?.errores;
            if (Array.isArray(errores) && errores.length > 0) {
                errores.forEach((item) => {
                    const mensaje = item?.item2 ?? item?.Item2 ?? 'No pudimos generar la previsión';
                    toast.error(mensaje);
                });
            } else {
                toast.error('No pudimos generar la previsión');
            }
        } finally {
            this.setState({ isLoadingSubmit: false });
        }
    }

    formatCurrency = (value) => {
        const numeric = Number(value ?? 0);
        if (Number.isNaN(numeric)) return '$0.00';
        return `$${numeric.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }

    formatInteger = (value) => {
        const numeric = Number(value ?? 0);
        if (Number.isNaN(numeric)) return '0';
        return numeric.toLocaleString('es-AR');
    }

    getErrorMessage = (item) => item?.item2 ?? item?.Item2 ?? 'Observación sin detalle';

    render() {
        const noOptionsMessage = () => 'Sin opciones';
        const loadingOptionsMessage = () => 'Cargando...';
        const listaSellers = Array.isArray(this.props.lista_sellers_liquidaciones)
            ? this.props.lista_sellers_liquidaciones.map(s => ({ label: s.label, value: s.value.toString() }))
            : [];
        const sellersSeleccionados = this.state.sellers;
        const isModoSellers = this.state.modoPrevision === PREVISION_MODO.SELLERS;
        const isModoDiaCorte = this.state.modoPrevision === PREVISION_MODO.DIA_CORTE;
        const resultado = this.state.resultadoPrevision;
        const detalles = Array.isArray(resultado?.sellers) ? resultado.sellers : [];
        const placeholderSellers = sellersSeleccionados.length > 0
            ? `${sellersSeleccionados.length} seleccionado(s)`
            : 'Buscar y seleccionar sellers';

        const fechaDesdeMin = this.state.fechaHasta
            ? addDaysToDate(this.state.fechaHasta, -PREVISION_MAX_DIAS_RANGO)
            : fechaDesdeMinima;
        const fechaDesdeMax = this.state.fechaHasta || '';
        const fechaHastaMin = this.state.fechaDesde || '';
        const fechaHastaMax = this.state.fechaDesde
            ? addDaysToDate(this.state.fechaDesde, PREVISION_MAX_DIAS_RANGO)
            : '';
        const observaciones = Array.isArray(resultado?.errores) ? resultado.errores : [];

        return (
            <div className="container gestion-liquidaciones liquidaciones-modulo">
                {this.state.isLoadingSubmit && (
                    <BigSpinner
                        message="Se está generando la previsión, aguarde unos instantes"
                        normalizeMessage={false}
                    />
                )}
                <LiquidacionesPageHeader
                    title="Generar previsión"
                    subtitle="Definí el tipo de cálculo, el rango de fechas y generá la previsión."
                />

                <form className="form-horizontal form-material gestion-liquidaciones-form" onSubmit={this.onSubmit}>
                    <LiquidacionesFilterCard
                        title="Parámetros de previsión"
                        icon="fa-sliders-h"
                        className="liquidaciones-prevision-card"
                        headerExtra={(
                            <span className="liquidaciones-prevision-hint">
                                <i className="fa fa-info-circle" aria-hidden="true" />
                                Rango máximo: {PREVISION_MAX_DIAS_RANGO} días
                            </span>
                        )}
                        actions={(
                            <LiquidacionesBtnCrear type="submit" icon="fa-chart-line" disabled={this.state.isLoadingSubmit}>
                                {this.state.isLoadingSubmit ? 'Generando...' : 'Generar previsión'}
                            </LiquidacionesBtnCrear>
                        )}
                    >
                        <div className="liquidaciones-prevision-modo mb-3">
                            <p className="gestion-liquidaciones-filtro-label mb-2">Tipo de previsión</p>
                            <div className="liquidaciones-prevision-modo-toggle" role="group" aria-label="Tipo de previsión">
                                <button
                                    type="button"
                                    className={`liquidaciones-prevision-modo-toggle__btn ${isModoSellers ? 'is-active' : ''}`}
                                    onClick={() => this.setModoPrevision(PREVISION_MODO.SELLERS)}
                                    disabled={this.state.isLoadingSubmit}
                                    aria-pressed={isModoSellers}
                                >
                                    Por sellers
                                </button>
                                <button
                                    type="button"
                                    className={`liquidaciones-prevision-modo-toggle__btn ${isModoDiaCorte ? 'is-active' : ''}`}
                                    onClick={() => this.setModoPrevision(PREVISION_MODO.DIA_CORTE)}
                                    disabled={this.state.isLoadingSubmit}
                                    aria-pressed={isModoDiaCorte}
                                >
                                    Por día de corte
                                </button>
                            </div>
                            <p className="liquidaciones-prevision-modo-copy">
                                {isModoSellers
                                    ? 'La previsión se calcula únicamente para los sellers que selecciones.'
                                    : 'La previsión se calcula para todos los sellers asociados al día de corte elegido.'}
                            </p>
                        </div>

                        <div className="row g-3 align-items-end">
                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="prevision-fecha-desde" className="gestion-liquidaciones-filtro-label mb-0">Desde</label>
                                <input
                                    id="prevision-fecha-desde"
                                    type="date"
                                    name="fechaDesde"
                                    className="form-control"
                                    onChange={this.myChangeHandler}
                                    min={fechaDesdeMin || fechaDesdeMinima}
                                    max={fechaDesdeMax}
                                    value={this.state.fechaDesde}
                                    disabled={this.state.isLoadingSubmit}
                                />
                            </div>

                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="prevision-fecha-hasta" className="gestion-liquidaciones-filtro-label mb-0">Hasta</label>
                                <input
                                    id="prevision-fecha-hasta"
                                    type="date"
                                    name="fechaHasta"
                                    className="form-control"
                                    onChange={this.myChangeHandler}
                                    min={fechaHastaMin}
                                    max={fechaHastaMax}
                                    value={this.state.fechaHasta}
                                    disabled={this.state.isLoadingSubmit}
                                />
                            </div>

                            {isModoDiaCorte && (
                                <div className="col-12 col-md-4 col-lg-3">
                                    <label className="gestion-liquidaciones-filtro-label mb-0" htmlFor="prevision-dia-corte">Día de corte</label>
                                    <Select
                                        inputId="prevision-dia-corte"
                                        value={this.state.diaCorte}
                                        options={PREVISION_DIAS_CORTE_OPTIONS}
                                        onChange={this.selectDiaCorte}
                                        styles={customStyleFilterWrap}
                                        {...filterSelectMenuPortalProps}
                                        isSearchable={false}
                                        components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                        isDisabled={this.state.isLoadingSubmit}
                                    />
                                </div>
                            )}

                            {this.isAuthorizedViewAll() && isModoSellers && (
                                <div className="col-12 col-md-4 col-lg-6">
                                    <label className="gestion-liquidaciones-filtro-label mb-0" htmlFor="prevision-sellers">Seller</label>
                                    <Select
                                        inputId="prevision-sellers"
                                        value={this.state.sellers}
                                        options={listaSellers}
                                        onChange={this.selectSellers}
                                        onMenuOpen={this.mapSellers}
                                        onInputChange={this.onSelectSearchInputSellers}
                                        styles={customStyleFilterWrap}
                                        {...filterSelectMenuPortalProps}
                                        isLoading={this.state.isLoadingSellersOptions}
                                        loadingMessage={loadingOptionsMessage}
                                        noOptionsMessage={noOptionsMessage}
                                        components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        controlShouldRenderValue={false}
                                        hideSelectedOptions={false}
                                        placeholder={placeholderSellers}
                                        isDisabled={this.state.isLoadingSubmit}
                                    />
                                </div>
                            )}
                        </div>

                        {this.isAuthorizedViewAll() && isModoSellers && sellersSeleccionados.length > 0 && (
                            <div className="liquidaciones-prevision-sellers mt-3">
                                <p className="gestion-liquidaciones-filtro-label mb-2">
                                    Sellers seleccionados ({sellersSeleccionados.length})
                                </p>
                                <div className="liquidaciones-prevision-sellers__chips">
                                    {sellersSeleccionados.map((seller) => (
                                        <span key={seller.value} className="liquidaciones-prevision-sellers__chip">
                                            <span className="liquidaciones-prevision-sellers__chip-text">{seller.label}</span>
                                            <button
                                                type="button"
                                                className="liquidaciones-prevision-sellers__chip-remove"
                                                onClick={() => this.removeSeller(seller.value)}
                                                aria-label={`Quitar seller ${seller.label}`}
                                                disabled={this.state.isLoadingSubmit}
                                            >
                                                ×
                                            </button>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </LiquidacionesFilterCard>
                </form>

                {resultado && (
                    <div className="gestion-liquidaciones-resultados liquidacion-detalle-seccion">
                        <div className="liquidaciones-prevision-metrics">
                            <div className="liquidaciones-prevision-metric liquidaciones-prevision-metric--highlight">
                                <span className="liquidaciones-prevision-metric__label">Total general</span>
                                <strong className="liquidaciones-prevision-metric__value">{this.formatCurrency(resultado.totalGeneral)}</strong>
                            </div>
                            <div className="liquidaciones-prevision-metric">
                                <span className="liquidaciones-prevision-metric__label">Sellers</span>
                                <strong className="liquidaciones-prevision-metric__value">{this.formatInteger(resultado.cantidadSellers)}</strong>
                            </div>
                            <div className="liquidaciones-prevision-metric">
                                <span className="liquidaciones-prevision-metric__label">Órdenes</span>
                                <strong className="liquidaciones-prevision-metric__value">{this.formatInteger(resultado.cantidadOrdenes)}</strong>
                            </div>
                        </div>

                        {observaciones.length > 0 && (
                            <div className="liquidaciones-prevision-alert" role="status">
                                <p className="liquidaciones-prevision-alert__title">Observaciones</p>
                                <ul>
                                    {observaciones.map((item, index) => (
                                        <li key={`prevision-obs-${index}`}>{this.getErrorMessage(item)}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        <div className="liquidacion-detalle-tabla-card">
                            <div className="liquidacion-detalle-tabla-card__header">
                                <h5 className="liquidacion-detalle-tabla-card__title mb-0">Detalle por seller</h5>
                                <span className="liquidacion-detalle-tabla-card__badge">
                                    {this.formatInteger(resultado.cantidadSellers)} seller{resultado.cantidadSellers !== 1 ? 's' : ''}
                                </span>
                            </div>
                            <div className="liquidacion-detalle-tabla-card__body">
                                {detalles.length === 0 ? (
                                    <div className="gestion-liquidaciones-empty mb-0">
                                        No hay sellers para mostrar en el detalle
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-hover liquidacion-detalle-tabla mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Seller</th>
                                                    <th className="text-end">Órdenes</th>
                                                    <th className="text-end">Total liquidación</th>
                                                    <th className="text-end">Total órdenes</th>
                                                    <th className="text-end">Comisiones c/IVA</th>
                                                    <th className="text-end">Costo fee c/IVA</th>
                                                    <th className="text-end">Envío cliente</th>
                                                    <th className="text-end">Total rebate</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detalles.map((seller, index) => (
                                                    <tr key={`${seller?.idSeller ?? 'seller'}-${index}`}>
                                                        <td>{seller?.razonSocial || `Seller ${seller?.idSeller ?? '-'}`}</td>
                                                        <td className="text-end">{this.formatInteger(seller?.cantidadOrdenes)}</td>
                                                        <td className="text-end">{this.formatCurrency(seller?.totalLiquidacion)}</td>
                                                        <td className="text-end">{this.formatCurrency(seller?.totalOrdenes)}</td>
                                                        <td className="text-end">{this.formatCurrency(seller?.totalComisionesConIva)}</td>
                                                        <td className="text-end">{this.formatCurrency(seller?.totalCostoFeeConIva)}</td>
                                                        <td className="text-end">{this.formatCurrency(seller?.totalEnvioCliente)}</td>
                                                        <td className="text-end">{this.formatCurrency(seller?.totalRebate)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    idSeller: state.general.idSeller,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones
});

export default connect(mapStateToProps, {
    fetchSellersFilterLiquidaciones
})(PrevisionLiquidacionesWrapper);
